import { z } from 'zod';
/** Which occurrence of a weekday in the month, for a schedule that runs monthly rather than weekly. */
export const FEED_POLLING_ORDINALITIES = [1, 2, 3, 4, 5];
/** Sunday is 0, the way `Date.getDay()` reports it and the way the stored schedule reads. */
export const FEED_POLLING_DAYS_OF_WEEK = [0, 1, 2, 3, 4, 5, 6];
export const FEED_POLLING_HOURS = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
];
/** Fixed intervals rather than any number of minutes, so a schedule always divides the hour. */
export const FEED_POLLING_INTERVAL_MINUTES = [
    1, 2, 5, 10, 15, 30, 60, 120, 360, 720, 1440,
];
/**
 * When a pull feed goes looking for new rows. Unknown keys are dropped rather than rejected: the
 * staff form has round-tripped stored schedules through this shape for long enough to carry
 * extras.
 */
export const FeedPollingScheduleSchema = z.object({
    daysOfWeek: z.array(z.object({
        day: z.literal(FEED_POLLING_DAYS_OF_WEEK),
        ordinality: z.literal(FEED_POLLING_ORDINALITIES).optional(),
    })),
    firstHour: z.literal(FEED_POLLING_HOURS),
    lastHour: z.literal(FEED_POLLING_HOURS),
    intervalMinutes: z.literal(FEED_POLLING_INTERVAL_MINUTES),
});
//# sourceMappingURL=pollingSchedule.js.map